<template>
  <div class="bargain-active-index">

    <div class="d-b-c">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label=""><el-input v-model="searchForm.search" placeholder="请输入物流中心名称"></el-input></el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <div class="table-wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="anchor_id" label="ID" width="60"></el-table-column>

          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="mobile" label="手机" width="120"></el-table-column>
          <el-table-column prop="wechat" label="微信" width="100"></el-table-column>
          <el-table-column prop="platform" label="来源" width="100"></el-table-column>
          <el-table-column prop="create_time" label="添加时间" width="140"></el-table-column>
          <el-table-column prop="update_time" label="更新时间" width="140"></el-table-column>
          <el-table-column prop="name" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="editAnchor(scope.row)" type="text" size="small">详情</el-button>
              <!-- <el-button @click="deleteArticle(scope.row)" type="text" size="small">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>

    </div>
  </div>
</template>

<script>
import AnchorApi from "@/api/anchor.js";
export default {
  components: {},
  data() {
    return {
      /*搜索表单对象*/
      searchForm: {},
      /*表单数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      commentData: [],
      loading: true,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
    };
  },
  created() {
    /*获取文章列表*/
    this.getTableList();
  },
  methods: {
    /*查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },
    /*获取文章列表*/
    getTableList() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      AnchorApi.anchorlist(Params, true)
        .then((data) => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch((error) => {
          self.loading = false;
        });
    },

    /*编辑文章*/
    editAnchor(row) {
      let params = row.anchor_id;
      this.$router.push({
        path: "/plus/anchor/anchor/detail",
        query: {
          anchor_id: params,
        },
      });
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getData();
    },

  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/anchor/anchor/Index.vue